export default __webpack_public_path__ + "static/soehne-web-extrafett-3af3ecb48fd66897e10e7588c64174a1.eot";